import React, { useState, useContext } from "react";
import { Menu, Dropdown, Button, Space, Layout, Row, Col, Modal } from "antd";
import {
    CaretDownOutlined,
    ExclamationCircleOutlined,
} from "@ant-design/icons";

import JsZip from "jszip";
import FileSaver from "file-saver";

import { GlobalContext } from "./GlobalContext";

import Uploader from "./Uploader";
import DataViewer from "./DataViewer";

const { Header } = Layout;

const Toolbar = () => {
    const { setDefaultUserData, userData } = useContext(GlobalContext);
    const [uploaderVisible, setUploaderVisible] = useState(false);
    const [dataViewerVisible, setDataViewerVisible] = useState(false);

    const exportZip = () => {
        const zip = JsZip();

        if (userData) {
            Object.keys(userData).map((key) => {
                if (
                    key !== "profile_p1" &&
                    key !== "profile_p2" &&
                    key !== "mods"
                ) {
                    let hasData = userData[key] && userData[key].length > 0;
                    if (hasData) {
                        return zip.file(
                            key + ".json",
                            JSON.stringify(userData[key], null, 2)
                        );
                    }
                } else {
                    return zip.file(
                        key + ".json",
                        JSON.stringify(userData[key], null, 2)
                    );
                }

                return null;
            });
            zip.generateAsync({ type: "blob" }).then((zipFile) => {
                const currentDate = new Date().getTime();
                const fileName = `UserData-${currentDate}.zip`;
                return FileSaver.saveAs(zipFile, fileName);
            });
        }
    };

    function handleMenuClick(e) {
        if (e.key === "load") {
            setUploaderVisible(true);
        } else if (e.key === "new") {
            showNewConfirm();
        } else if (e.key === "raw-json") {
            setDataViewerVisible(true);
        }
    }

    function showNewConfirm() {
        Modal.confirm({
            title: "Are you sure?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            content:
                "Any unsaved data will be lost. Are you sure you want to create a new profile?",
            onOk() {
                setDefaultUserData();
            },
            onCancel() {},
        });
    }

    const fileMenu = (
        <Menu
            onClick={handleMenuClick}
            style={{
                width: `150px`,
            }}
            items={[
                {
                    label: "New",
                    key: "new",
                },
                {
                    label: "Load files...",
                    key: "load",
                },
                {
                    label: "",
                    type: "divider",
                    key: "4",
                },
                {
                    label: "Export to ZIP...",
                    key: "5",
                    onClick: exportZip,
                },
            ]}
        />
    );

    const viewMenu = (
        <Menu
            onClick={handleMenuClick}
            style={{
                width: `150px`,
            }}
            items={[
                {
                    label: "Data Viewer",
                    key: "raw-json",
                },
            ]}
        />
    );

    return (
        <>
            <Header
                style={{
                    padding: `0`,
                }}
            >
                <Row>
                    <Col
                        span={3}
                        style={{
                            flex: "0 0 200px",
                            maxWidth: "200px",
                            minWidth: "200px",
                            width: "200px",
                            padding: `0 0 0 24px`,
                        }}
                    >
                        <h3
                            style={{
                                color: `white`,
                                fontFamily: `nijiiro`,
                                fontSize: `16px`,
                            }}
                        >
                            {`Nijiiro Save Tool`}
                        </h3>
                    </Col>
                    <Col span={6}>
                        <Space wrap style={{ marginLeft: `12px` }}>
                            <Dropdown overlay={fileMenu} trigger={["click"]}>
                                <Button
                                    onClick={(e) => e.preventDefault()}
                                    style={{
                                        background: `transparent`,
                                        borderColor: `rgba(255,255,255,0.1)`,
                                    }}
                                >
                                    <Space>
                                        <span
                                            style={{
                                                color: `white`,
                                            }}
                                        >
                                            File
                                        </span>
                                        <CaretDownOutlined
                                            style={{
                                                color: `white`,
                                            }}
                                        />
                                    </Space>
                                </Button>
                            </Dropdown>

                            <Dropdown overlay={viewMenu} trigger={["click"]}>
                                <Button
                                    onClick={(e) => e.preventDefault()}
                                    style={{
                                        background: `transparent`,
                                        borderColor: `rgba(255,255,255,0.1)`,
                                    }}
                                >
                                    <Space>
                                        <span
                                            style={{
                                                color: `white`,
                                            }}
                                        >
                                            View
                                        </span>
                                        <CaretDownOutlined
                                            style={{
                                                color: `white`,
                                            }}
                                        />
                                    </Space>
                                </Button>
                            </Dropdown>
                        </Space>
                    </Col>
                </Row>
            </Header>
            <Uploader
                uploaderVisible={uploaderVisible}
                setUploaderVisible={setUploaderVisible}
            />
            <DataViewer
                dataViewerVisible={dataViewerVisible}
                setDataViewerVisible={setDataViewerVisible}
            />
        </>
    );
};

export default Toolbar;
